import { Link } from "react-router-dom";
import { buildWhatsAppLink } from "../../lib/whatsapp";
import { Mail, MessageCircle } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0A0A0A] text-[#F8F5F0] mt-32">
      <div className="container-mps py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="font-serif text-3xl text-[#C9A96E] mb-4">My Private Shopper</div>
            <p className="text-[#E5E0D8]/70 max-w-md leading-relaxed">
              A premium UK-to-Nigeria personal shopping concierge. We source, purchase,
              and ship UK products directly to clients across all 36 Nigerian states.
            </p>
            <div className="mt-8 flex items-center gap-3">
              <a
                href={buildWhatsAppLink()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-cta"
                className="inline-flex items-center gap-2 px-5 py-3 bg-[#25D366] text-[#0A0A0A] text-sm uppercase tracking-[0.16em] hover:bg-[#1EBE5C] transition-colors"
              >
                <MessageCircle size={16} /> WhatsApp
              </a>
              <a
                href="mailto:ops@privateshopper.co.uk"
                data-testid="footer-email-cta"
                className="inline-flex items-center gap-2 px-5 py-3 border border-[#C9A96E]/40 text-[#F8F5F0] text-sm uppercase tracking-[0.16em] hover:bg-[#C9A96E] hover:text-[#0A0A0A] transition-colors"
              >
                <Mail size={16} /> Email
              </a>
            </div>
          </div>

          <div className="md:col-span-2">
            <div className="overline text-[#C9A96E] mb-5">Services</div>
            <ul className="space-y-3 text-sm text-[#E5E0D8]/80">
              <li><Link to="/services" className="hover:text-[#C9A96E]">Personal Shopping</Link></li>
              <li><Link to="/services" className="hover:text-[#C9A96E]">Business (B2B)</Link></li>
              <li><Link to="/services" className="hover:text-[#C9A96E]">Gift Sourcing</Link></li>
              <li><Link to="/services" className="hover:text-[#C9A96E]">Luxury & Designer</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="overline text-[#C9A96E] mb-5">Site</div>
            <ul className="space-y-3 text-sm text-[#E5E0D8]/80">
              <li><Link to="/how-it-works" className="hover:text-[#C9A96E]">How It Works</Link></li>
              <li><Link to="/pricing" className="hover:text-[#C9A96E]">Pricing</Link></li>
              <li><Link to="/faq" className="hover:text-[#C9A96E]">FAQ</Link></li>
              <li><Link to="/blog" className="hover:text-[#C9A96E]">Blog</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="overline text-[#C9A96E] mb-5">Contact</div>
            <ul className="space-y-3 text-sm text-[#E5E0D8]/80">
              <li>ops@privateshopper.co.uk</li>
              <li>WhatsApp: +44 7823 718667</li>
              <li>London, United Kingdom</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#C9A96E]/20 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-xs text-[#E5E0D8]/60">
          <div>© {new Date().getFullYear()} My Private Shopper · privateshopper.co.uk</div>
          <div className="overline">Trusted UK-to-Nigeria Concierge Since 2011</div>
        </div>
      </div>
    </footer>
  );
}
